export enum InstitutionApplicationStatus {
  REFUSED = -1,
  IN_PROGRESS = 0,
  ACCEPTED = 1,
  DESACTIVATED = -2,
  INCOMPLETE = 2,
  INVITED = 3,
  TEMPORARY_SUSPENDED = 4,
  EXCLUDED = 5,
}

export enum InstitutionCountry {
  FR = 'fr',
  DE = 'de',
  CH = 'ch',
  ES = 'es',
  BE = 'be',
}
